import { z } from 'zod';

/** Papéis de usuário da loja. */
export const PAPEIS = ['dono', 'gerente', 'vendedor', 'financeiro'] as const;
export const papelSchema = z.enum(PAPEIS);
export type Papel = z.infer<typeof papelSchema>;

/** Papéis que exigem MFA (docs/02). */
export const PAPEIS_COM_MFA_OBRIGATORIO: readonly Papel[] = ['dono', 'financeiro'];

/** Papéis internos do admin. */
export const PAPEIS_INTERNOS = [
  'administrador',
  'suporte',
  'financeiro_interno',
  'parceiro_comercial',
] as const;
export const papelInternoSchema = z.enum(PAPEIS_INTERNOS);
export type PapelInterno = z.infer<typeof papelInternoSchema>;

/** Papéis que podem ver custo, margem e lucro. Vendedor nunca vê. */
export const PAPEIS_VEEM_CUSTO: readonly Papel[] = ['dono', 'gerente', 'financeiro'];

export const podeVerCusto = (papel: Papel): boolean => PAPEIS_VEEM_CUSTO.includes(papel);
